import { useDispatch } from "react-redux";
import { Animate } from "react-simple-animate";
import {  incrementLoginStep } from "../../../../Features/Misc/loginSlice"


import NextStepButton from "../../../Components/NextStepButton";
import MediaFooter from "../../../Components/MediaFooter";
import SubMem from "./SubMem";
import BackAndForthButton from "../Signup/BackAndForthButton";
import Footer from "../../../Components/Footer";

export default function WelcomeLeft() {

    //redux methods
    const dispatch = useDispatch();


    const landingBoxSuperTitle = "A sleep toolbox that improves your sleep health"
    const landingBoxTitle = "Welcome to kipmate"
    const landingBoxContent = "Our digital tool is designed to help improve your sleep health and sort your kip. Sign up to be the first to know when it is launched and to get some great offers."
    const landingBoxButtonText = "Log in or Sign up to access your account!"

    return (

        <>

        <div className={` lg:hidden h-full submem-outer`}>

            <SubMem />
        </div>

        <div className={`hidden lg:grid WelcomeLeft col-start-1 col-end-13 row-start-2 lg:row-start-4 row-end-13 grid-cols-12 grid-rows-12 `}>
            <Animate play
                     start={{opacity: 0}}
                     end={{
                         opacity: 1,
                         gridRowStart: 1,
                         gridRowEnd: 13,
                         display: "grid",
                         gridColumnStart: 1,
                         gridColumnEnd: 13,
                         gridTemplateRows: "repeat(12, minmax(0, 1fr))",
                         gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                     }}
                     duration={0.7} >
            <div className={`WelcomeLeft__superTitle lg:row-start-2 lg:row-end-2 text-lg font-semibold col-start-3 col-end-11 lg:col-start-1 lg:col-end-11 text-center lg:text-left `}>{landingBoxSuperTitle}</div>

            <div className={`WelcomeLeft__title text-2xl lg:text-4xl row-start-4 row-end-5 lg:row-start-3 lg:row-end-3 text-center font-semibold col-start-1 col-end-13 lg:col-start-1 lg:col-end-12 text-center lg:text-left`}>{landingBoxTitle}</div>
            <div className="WelcomeLeft__content row-start-5 row-end-8 lg:row-start-5 lg:row-end-7 col-start-2 col-end-12 lg:col-start-1 lg:col-end-10 bg text-center lg:text-left">{landingBoxContent}</div>
            <div onClick={() => dispatch(incrementLoginStep())} className={`WelcomeLeft__-action row-start-7 lg:row-start-8 row-end-8 lg:row-end-9   font-semibold text-lg   cursor-pointer  col-start-3 col-end-11 lg:col-start-1 lg:col-end-9 text-center lg:text-left }`}>{landingBoxButtonText} </div>
            <div className="WelcomeLeft__pagination flex px-2 row-start-8 row-end-9 col-start-6 col-end-8 lg:row-start-11 lg:row-end-12 lg:col-start-1 lg:col-end-12 items-center text-2xl justify-between">
                <div className=" flex flex-row progressBar h-1 rounded-lg gap-2  w-20 ">
                    <div className="h1 bg-pink-icon rounded-lg w-6"></div>
                    <div className="h1  bg-pink-dashboard  rounded-lg w-12"></div>
                </div>
                <div className="arrows-container hidden lg:flex flex-row gap-6">
                    <BackAndForthButton type="decrement"/>
                    <BackAndForthButton type="increment" />
                </div>
            </div>

            <NextStepButton
                positionClassNames={`col-start-5 col-end-9  row-start-9 row-end-10 `}
                styleClassNames={" lg:hidden flex flex-row justify-center items-center bg-gold-accent hover:bg-gold-accent-hover rounded-lg  h-12  py-1 text-xl "}
                pClassNames={" text-xl p-3  align-center justify-center flex "}
                iClassNames={" ri-arrow-right-line "}
                pContent={`Next `}
            />

            <MediaFooter className={`col-start-1 col-end-13 row-start-11 row-end-12 flex items-center justify-center lg:hidden`} />
            {/*<Footer className={`col-start-1 col-end-13 row-start-12 lg:row-start-13 text-sm row-end-13 text-pink-icon hidden lg:flex items-center justify-start`}/>*/}
                <Footer className={`col-start-1 col-end-13 row-start-13  text-sm row-end-13 text-pink-icon hidden lg:flex items-center justify-start`}/>
            </Animate>
        </div>
        </>
        
    );
}
